import { Directive, HostListener, Input } from '@angular/core';
import { ChainResponsibilityService } from 'src/app/services/chain-responsibility/chain-responsibility.service';
import { ChainSenders } from 'src/app/services/chain-responsibility/chain.interface';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';

@Directive({
    selector: '[asgClickHandler]',
    standalone: true
})
export class MainClickDirectiveDirective {

  private clickHandler: () => void;

  @Input('asgClickHandler')
  set client(clickHandler: () => void) {
    this.clickHandler = clickHandler;
  }

  private clickParams: any = null;
  @Input()
  set asgClickParams(clickParams: any) {
    this.clickParams = clickParams;
  }

  feature: AsgardFeatureNames;
  @Input()
  set asgardFeature(f: AsgardFeatureNames) {
    this.feature = f;
  }

  constructor(
    private readonly chainResp: ChainResponsibilityService,
  ) {
  }

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    // console.log('onClick:', event);
    event.stopPropagation();
    this.chainResp.handleClickEvent(ChainSenders.UI, this.feature, null, null, event, this.clickHandler, this.clickParams);
  }
}
